import React from 'react';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Card from '@mui/material/Card';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import SelectAvailableScreensNew from './SelectAvailableScreensNew';
import axios from 'axios';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import * as ETVConstants from '../ETVConstants';
import { OutlinedInput,Paper } from '@mui/material';
import MessageDialog from '../tools/MessageDialog';


class EditText extends React.Component {

    constructor(props) {
      super(props);
      this.onMouseOut = this.onMouseOut.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
      this.loadBG = this.loadBG.bind(this);
      this.readerLoaded = this.readerLoaded.bind(this);
      this.bgImageLoaded = this.bgImageLoaded.bind(this);
      this.closeScreenSelection = this.closeScreenSelection.bind(this);
      this.selectedScreens = this.selectedScreens.bind(this);
      this.closeInfoMessage = this.closeInfoMessage.bind(this);
    }

    state = {
      items:[],
      canvas:undefined,
      ctx:undefined,
      cWidth:1024,
      cHeight:768,
      canvas_width: 1024,
      canvas_height: 768,
      canvasResolution:1.33333,
      font:"Tahoma",
      textSize:64,
      fontStyle:'normal',
      canvas_bg_color: '#e5decf',
      needRedraw: false,
      state_writing:false,
      textColor:'#0A0A0A',
      status:0,
      currentPos:{x:0,y:0},
      canvas_bg: undefined,
      canvas_img: undefined,
      final_image: undefined,
      channel: 0,
      selected_screens: [],
      template_items:[],
      window:'',
      info_message:'',
      info_title:'',
      info_type:'',
    }

    resetDrawing() {
      var defstate = {
        items:[],
        cWidth:1024,
        cHeight:768,
        canvas_width: 1024,
        canvas_height: 768,
        canvasResolution:1.33333,
        canvas_bg_color: '#e5decf',
        needRedraw: true,
        state_writing:false,
        textColor:'#0A0A0A',
        status:0,
        currentPos:{x:0,y:0},
        canvas_bg: undefined,
        canvas_img: undefined,
        final_image: undefined,
        window: undefined,
      }
      this.setState(defstate);
    }

    componentDidMount() {
      this.loadTemplates();
      const canvas = this.refs.canvas;
      const ctx = canvas.getContext("2d")
      const img = this.refs.image
      this.setState({ctx:ctx, canvas:canvas});
      this.drawCanvasContent();
    }

    componentDidUpdate() {
      if(this.state.needRedraw) {
        const canvas = this.refs.canvas;
        const ctx = canvas.getContext("2d");
        const img = this.refs.image;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        this.setState({ctx:ctx, canvas:canvas, needRedraw:false});
        this.drawCanvasContent();
      }
    }

    readerLoaded = (e) => {
      const content = e.target.result;
      var image = new Image();
      image.src = e.target.result;
      image.onload = this.bgImageLoaded;
      this.setState({canvas_img:image, canvas_bg:e.target.result,window:''});
    }

    loadBG(selectorFiles) {
      var file = selectorFiles[0];
      var reader  = new FileReader();
      reader.onloadend = this.readerLoaded;
      if (file) {
        reader.readAsDataURL(file);
      }
    }

    bgImageLoaded(image) {
      this.setState({cWidth:this.state.canvas_img.width,cHeight:this.state.canvas_img.height, bgImage:image, canvas_bg_color:'#FFFFFF',items:[],needRedraw:true});
    }

    createTextObject( text, pos, textSize, font, fontStyle, textColor, stateDrawing) {
    	var o = new Object();
    	o.text = text;
    	o.pos = pos;
    	o.textSize = textSize;
    	o.font = font;
    	o.fontStyle = fontStyle;
    	o.textColor = textColor;
    	o.stateDrawing = stateDrawing;
    	return o;
    }

    addTextObject( obj) {
      var newItems = [];
      for(var i=0; i<this.state.items.length; i++) {
        var item = this.state.items[i];
        newItems.push(item);
      }
      newItems.push(obj);
      this.setState({items:newItems, needRedraw:true});
    }

    drawCanvasContent() {
      if(!this.state.ctx) return;
      this.state.ctx.clearRect(0, 0, this.state.canvas.width, this.state.canvas.height);
      var items = this.state.items;
      for(var i=0; i<items.length; i++) {
        this.drawText(items[i]);
      }
    }

    drawText( textObj) {
    	this.state.ctx.font = textObj.fontStyle+" "+textObj.textSize+"px "+textObj.font;
    	this.state.ctx.fillStyle = textObj.textColor;
    	if (textObj.stateDrawing) {
    		this.state.ctx.fillText(textObj.text+"_", textObj.pos.x, textObj.pos.y);
    	}else{
    		this.state.ctx.fillText(textObj.text, textObj.pos.x, textObj.pos.y);
    	}
    }

    // ---- NEW: hit-test helper for re-editing existing text ----
    getItemAtPoint(pt) {
      const ctx = this.state.ctx;
      if (!ctx) return -1;
      // check top-most first
      for (let i = this.state.items.length - 1; i >= 0; i--) {
        const it = this.state.items[i];
        ctx.font = it.fontStyle + " " + it.textSize + "px " + it.font;
        const text = it.text && it.text.length ? it.text : " ";
        const w = ctx.measureText(text).width;
        const h = it.textSize; // approx height
        const x0 = it.pos.x;
        const y0 = it.pos.y - h;
        const x1 = x0 + w;
        const y1 = it.pos.y;
        if (pt.x >= x0 && pt.x <= x1 && pt.y >= y0 && pt.y <= y1) {
          return i;
        }
      }
      return -1;
    }
    // -----------------------------------------------------------

    handleCanvasClick = (evt) => {
      const coord = this.getMousePos(this.state.canvas,evt);

      // Try selecting an existing item to re-edit
      const hitIndex = this.getItemAtPoint(coord);
      if (hitIndex >= 0) {
        // set only that item to drawing=true
        const newItems = this.state.items.map((it, i) => {
          const copy = { ...it };
          copy.stateDrawing = (i === hitIndex);
          return copy;
        });
        this.setState({ items: newItems, currentPos: coord, status: 1, needRedraw: true });
        return;
      }

      // Otherwise, create a new item
      this.setAllNonDrawing();
      var tObj = this.createTextObject( "", coord, this.state.textSize, this.state.font, this.state.fontStyle, this.state.textColor, true);
      this.addTextObject(tObj);
      this.setState({currentPos:coord, status:1, needRedraw:true});
    }

    setAllNonDrawing() {
      var newItems = [];
      for(var i=0; i<this.state.items.length; i++) {
        var item = this.state.items[i];
        item.stateDrawing = false;
        newItems.push(item);
      }
      this.setState({items:newItems,needRedraw:true});
    }

    getMousePos(canvas, evt) {
        var rect = this.state.canvas.getBoundingClientRect();
        return {
          x: evt.clientX - rect.left,
          y: evt.clientY - rect.top
        };
    }

    appendChar(ch) {
      var newItems = [];
      for(var i=0; i<this.state.items.length; i++) {
        var curItem = this.state.items[i];
        var additionalItem = undefined;
        if(curItem.stateDrawing) {
          if(ch==="Tab") {
            curItem.text = curItem.text+"    ";

          }else if(ch==="Enter") {
            curItem.stateDrawing = false;
            var newPos = {x:curItem.pos.x, y:curItem.pos.y + 1.2* curItem.textSize};
            additionalItem = this.createTextObject("", newPos, curItem.textSize, curItem.font, curItem.fontStyle, curItem.textColor, true);

          }else if(ch==="Backspace" || ch==="Delete") {
            if(curItem.text.length>0) {
              curItem.text = curItem.text.substring(0,curItem.text.length-1);
              if(curItem.text.length===0) {
                curItem = undefined;
                if(newItems.length>0) {
                  newItems[newItems.length-1].stateDrawing=true;
                }
              }
            }else{
              curItem = undefined;
              if(newItems.length>0) {
                newItems[newItems.length-1].stateDrawing=true;
              }
            }

          }else if(!this.isSpecialCharacter(ch)){
            curItem.text = curItem.text + ch;
          }
        }
        if(curItem) {
          newItems.push(curItem);
        }
        if(additionalItem) {
          newItems.push(additionalItem);
        }
      }
      this.setState({items:newItems, needRedraw:true});
    }

    isSpecialCharacter( ch) {
      if(ch==="Shift") return true;
      if(ch==="Control") return true;
      if(ch==="Alt") return true;
      if(ch==="Meta") return true;
      if(ch==="Insert") return true;
      if(ch==="PageUp") return true;
      if(ch==="PageDown") return true;
      if(ch==="End") return true;
      if(ch==="Home") return true;
      if(ch==="ArrowUp") return true;
      if(ch==="ArrowDown") return true;
      if(ch==="ArrowLeft") return true;
      if(ch==="ArrowRight") return true;
      if(ch==="CapsLock") return true;
      if(ch==="Esc") return true;
      return false;
    }

    handleCanvasResolutionChange(ratio, adaptUserField) {

      var y = 768;
      var x = y*ratio;
      if(ratio>=1) {
        x = 1024;
        y = x/ratio;
      }
      if(ratio===1) {
        x = 800;
        y = 800;
      }
      x = Math.round(x);
      y = Math.round(y);

      if(adaptUserField) {
        this.setState({canvas_width:x,canvas_height:y});
      }
      this.setState({canvasResolution:ratio, cWidth:x, cHeight:y});
      this.setAllNonDrawing();
    }

    handleFontChange = (event) => {
      var font = event.target.value;
      this.setState({font:font, needRedraw:true});
    }

    handleTextSizeChange = (event) => {
      var txtsize = event.target.value;
      this.setState({textSize:txtsize, needRedraw:true});
    }

    handleFontStyleChange = (event) => {
      var fontStyle = event.target.value;
      this.setState({fontStyle:fontStyle, needRedraw:true});
    }

    handleChannelChange = (event) => {
      var ch = event.target.value;
      this.setState({channel:ch, needRedraw:true});
    }

    onMouseOut() {
      this.setAllNonDrawing();
    }

    onKeyDown(event) {
      var ch = event.key;
      if(this.state.status===1) {
        this.appendChar(ch);
      }else{
      }
    }

    prepareUploadImage() {
      var canvas = this.state.canvas;
      var ctx = canvas.getContext("2d");

      if(this.state.canvas_bg_color) {
        ctx.fillStyle = this.state.canvas_bg_color;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
      }

      if(this.state.canvas_bg) {
        var image = new Image();
        image.src = this.state.canvas_bg;
        ctx.drawImage(image,0,0);
      }
      for(var i=0; i<this.state.items.length; i++) {
          this.state.items[i].stateDrawing = false;
          this.drawText(this.state.items[i]);
      }
      if(this.state.canvas) {
        var data = this.state.canvas.toDataURL("image/png");
      }
      this.uploadImage( this.props.user_id, data, this.state.selected_screens, this.state.channel, this.state.canvasResolution);
      this.setState({canvas_bg:undefined,items:[],needRedraw:true,canvas_bg_color:'#FFFFFF',textColor:'#0A0A0A',channel:0});
    }

    showWindow(divID, show) {
      show?this.setState({window:divID}):this.setState({window:''});
    }

    showInfoMessage(title, msg) {
      this.setState({window:'message_div',info_title:title, info_message:msg, info_type:'info'});
    }

    showSuccessMessage(title, msg) {
      this.setState({window:'message_div',info_title:title, info_message:msg, info_type:'success'});
    }

    showErrorMessage(title, msg) {
      this.setState({window:'message_div',info_title:title, info_message:msg, info_type:'error'});
    }

    closeInfoMessage() {
      this.setState({window:'',info_message:'',info_title:'',info_type:''});
    }

    closeScreenSelection() {
      this.showWindow('select_screens_div',false);
    }

    selectedScreens(screenIDs) {
      this.setState({window:'',selected_screens:screenIDs});
    }

    uploadImage( userID, imageData, screenIDs, channel, ratio) {
      this.showInfoMessage("",ETVConstants.trans("uploading..."));
      var d = new Date();
      var desc = "text created "+d.toLocaleString();
      var userID = this.props.user_id;
      var targetDir = "/"+userID+"/content_library";
      var myRand = Math.floor((Math.random() * 100000) + 1);
      var filename = myRand+"_text.png";

      var formData = new FormData();
      formData.append("user_id",userID);
      screenIDs.map( (item,i) => formData.append("device_id",item));
      formData.append("image_data",imageData);
      formData.append("channel",channel);
      formData.append("filename",filename);
      formData.append("target_dir",targetDir);
      formData.append("desc",desc);
      formData.append("content_ratio", ratio)

      const config = {
        headers: {	'content-type': 'multipart/form-data'}
      }
      var url = ETVConstants.getServerBase()+"/image_upload";
      axios.post(url, formData, config)
            .then((response) => {
                  this.showSuccessMessage("",ETVConstants.trans("successfully_uploaded"));
                })
                .catch((error) => {
                  this.showErrorMessage("","error: "+error);
                });
    }

    changeCustomCanvasSize(canvasWidth, canvasHeight) {
      this.setState({canvas_width:canvasWidth,canvas_height:canvasHeight});
      var ratio = canvasWidth/Math.max(1,canvasHeight);
      this.handleCanvasResolutionChange(ratio,false);
    }


    filterTemplateItems( marketPlaceRx) {
      var templates = [];
      for(var i=0; i<marketPlaceRx.length; i++) {
        if(marketPlaceRx[i].content_category==="template" && (marketPlaceRx[i].filename.toLowerCase().endsWith(".jpg") || marketPlaceRx[i].filename.toLowerCase().endsWith(".jpeg") || marketPlaceRx[i].filename.toLowerCase().endsWith(".png"))) {
          templates.push(marketPlaceRx[i]);
        }
      }
      this.setState({
        template_items: templates,
      });
    }

    loadTemplates() {
      var accessToken = localStorage.getItem("etv.access_token");
      var reqUserID = localStorage.getItem("etv.user_id");
      var url = ETVConstants.getServerBase()+"/content_library?action=list_market_place";
      fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
        .then(res => res.json())
        .then(
          (result) => {
            var rx = result.list;
            this.filterTemplateItems(rx);
          },
          (error) => {
            this.setState({
              error
            });
          }
        )
    }

    loadTemplate( item) {
      var reader = new FileReader();
      reader.onload = this.readerLoaded;
      var request = new XMLHttpRequest();
      request.open('GET', item.url, true);
      request.responseType = 'blob';
      request.onload = function() {
          reader.readAsDataURL(request.response);
      };
      request.send();
    }

    render() {

      var dropDownWidth = 240;

      return (
        <Card>
          <CardContent>
            <table cellSpacing="10"><tbody>
              <tr valign='top'>
                <td>
                  <Paper elevation={3}>
                    <div style={{marginLeft:10,paddingTop:20}}>
                        <FormControl>
                           <InputLabel id="sizeLabel">{ETVConstants.trans("resolution")}</InputLabel>
                           <Select
                             labelId="sizeLabel"
                             id="sizeID"
                             size="small"
                             input={<OutlinedInput label={"filter_type"} />}
                             style={{ width: dropDownWidth}}
                             value={this.state.canvasResolution}
                             onChange={(e) => {this.handleCanvasResolutionChange(e.target.value,true)}}>
                             <MenuItem value={1.33333}>4:3</MenuItem>
                             <MenuItem value={0.75}>3:4</MenuItem>
                             <MenuItem value={1.77777778}>16:9</MenuItem>
                             <MenuItem value={1}>Square</MenuItem>
                             <MenuItem value={7.8}>Banner 468x60</MenuItem>
                             <MenuItem value={8.0888889}>Leaderboard 728x90</MenuItem>
                             <MenuItem value={1.2}>Inline Rectangle 300x250</MenuItem>
                             <MenuItem value={0.2}>Skyscraper 120x600</MenuItem>
                             <MenuItem value={0.5}>Half-Page Ad 300x600</MenuItem>
                             <MenuItem value={10.77777778}>Large Leaderboard 970x90</MenuItem>
                           </Select>
                        </FormControl>
                        <div>
                          <FormControl style={{marginTop:20}}>
                              <TextField key='canvas_width'
                                  label={ETVConstants.trans("width_pixels")}
                                  type="number"
                                  fullWidth
                                  size="small"
                                  InputProps={{ inputProps: { min: 0, max: 2048 } }}
                                  value={this.state.canvas_width}
                                  style = {{width: 90}}
                                  onChange={(event)=>{this.changeCustomCanvasSize(event.target.value,this.state.canvas_height)}} />
                          </FormControl>
                          <FormControl style={{marginTop:20}}>
                              <TextField key='canvas_height'
                                  label={ETVConstants.trans("height_pixels")}
                                  type="number"
                                  size="small"
                                  InputProps={{ inputProps: { min: 0, max: 2048 } }}
                                  style = {{width: 95, marginLeft:10,}}
                                  value={this.state.canvas_height}
                                  onChange={(event)=>{this.changeCustomCanvasSize(this.state.canvas_width,event.target.value)}} />
                          </FormControl>                                          
                        </div>
                    </div>
                    <div style={{marginLeft:10}}>
                       <FormControl style={{marginTop:20}}>
                          <InputLabel>{ETVConstants.trans("font")}</InputLabel>
                          <Select
                            labelId="fontlabelID"
                            id="fontID"
                            style={{ width: dropDownWidth}}
                            value={this.state.font}
                            size="small"
                            input={<OutlinedInput label={"font"} />}
                            onChange={this.handleFontChange}>
                            <MenuItem value='Arial'>Arial</MenuItem>
                  					<MenuItem value='Arial Black'>Arial Black</MenuItem>
                  					<MenuItem value='Bookman'>Bookman</MenuItem>
                  					<MenuItem value='Calibri'>Calibri</MenuItem>
                  					<MenuItem value='Comic Sans MS'>Comic Sans MS</MenuItem>
                  					<MenuItem value='Courier New'>Courier New</MenuItem>
                  					<MenuItem value='Courier'>Courier</MenuItem>
                  					<MenuItem value='Garamond'>Garamond</MenuItem>
                  					<MenuItem value='Georgia'>Georgia</MenuItem>
                  					<MenuItem value='Helvetica'>Helvetica</MenuItem>
                  					<MenuItem value='Impact'>Impact</MenuItem>
                  					<MenuItem value='Lucida Sans Unicode'>Lucida Sans Unicode</MenuItem>
                  					<MenuItem value='MS PGothic'>MS PGothic</MenuItem>
                  					<MenuItem value='MS Gothic'>MS Gothic</MenuItem>
                  					<MenuItem value='MS PMing'>MS PMing</MenuItem>
                  					<MenuItem value='Palatino'>Palatino</MenuItem>
                  					<MenuItem value='Sans-Serif'>Sans-Serif</MenuItem>
                  					<MenuItem value='Serif'>Serif</MenuItem>
                  					<MenuItem value='Tahoma'>Tahoma</MenuItem>
                  					<MenuItem value='Times New Roman'>Times New Roman</MenuItem>
                  					<MenuItem value='Times'>Times</MenuItem>
                  					<MenuItem value='Trebuchet MS'>Trebuchet MS</MenuItem>
                  					<MenuItem value='Verdana'>Verdana</MenuItem>
                          </Select>
                        </FormControl>
                    </div>
                    <div style={{marginLeft:10}}>
                        <FormControl style={{marginTop:20}}>
                           <InputLabel>{ETVConstants.trans("text_size")}</InputLabel>
                           <Select
                             labelId="textSizeLabelID"
                             id="textSize"
                             size="small"
                             style={{ width: dropDownWidth}}
                             input={<OutlinedInput label={"text_size"} />}
                             value={this.state.textSize}
                             onChange={this.handleTextSizeChange}>
                             <MenuItem value='10'>10pt</MenuItem>
                             <MenuItem value='12'>12pt</MenuItem>
                             <MenuItem value='16'>16pt</MenuItem>
                             <MenuItem value='18'>18pt</MenuItem>
                             <MenuItem value='20'>20pt</MenuItem>
                             <MenuItem value='24'>24pt</MenuItem>
                             <MenuItem value='30'>30pt</MenuItem>
                             <MenuItem value='36'>36pt</MenuItem>
                             <MenuItem value='40'>40pt</MenuItem>
                             <MenuItem value='44'>44pt</MenuItem>
                             <MenuItem value='48'>48pt</MenuItem>
                             <MenuItem value='56'>56pt</MenuItem>
                             <MenuItem value='64'>64pt</MenuItem>
                             <MenuItem value='72'>72pt</MenuItem>
                             <MenuItem value='80'>80pt</MenuItem>
                             <MenuItem value='88'>88pt</MenuItem>
                             <MenuItem value='96'>96pt</MenuItem>
                             <MenuItem value='102'>102pt</MenuItem>
                             <MenuItem value='116'>116pt</MenuItem>
                             <MenuItem value='128'>128pt</MenuItem>
                             <MenuItem value='150'>150pt</MenuItem>
                             <MenuItem value='175'>175pt</MenuItem>
                             <MenuItem value='200'>200pt</MenuItem>
                             <MenuItem value='256'>256pt</MenuItem>
                           </Select>
                         </FormControl>
                    </div>
                    <div style={{marginLeft:10}}>
                         <FormControl style={{marginTop:20}}>
                            <InputLabel>{ETVConstants.trans("font_style")}</InputLabel>
                            <Select
                              labelId="FontStyleLabelID"
                              id="fontStyleID"
                              size="small"
                              style={{ width: dropDownWidth}}
                              input={<OutlinedInput label={"text_size"} />}
                              value={this.state.fontStyle}
                              onChange={this.handleFontStyleChange}>
                              <MenuItem value='normal'>normal</MenuItem>
                              <MenuItem value='italic'>italic</MenuItem>
                              <MenuItem value='bold'>bold</MenuItem>
                            </Select>
                          </FormControl>
                    </div>
                    <br/>
                      <div style={{marginLeft:10}}>
                          <Typography variant="body2">{ETVConstants.trans("font_color")}</Typography>
                          <input type="color" style={{marginTop:5}} value={this.state.textColor} onChange={e => this.setState({textColor:e.target.value, needRedraw:true} )} />
                      </div>
                      <br/>
                      <div style={{marginLeft:10}}>
                          <Typography variant="body2">{ETVConstants.trans("background_color")}</Typography>
                          <input type="color" style={{marginTop:5}} value={this.state.canvas_bg_color} onChange={e => this.setState({canvas_bg_color:e.target.value, needRedraw:true} )} />
                      </div>
                      <br/>
                    </Paper>
                    <br/>
                    <Paper elevation={3} xs={{marginTop:20}}>
                      <div style={{marginLeft:10, paddingTop:20, marginRight:10}}>
                          <Typography variant="body2">{ETVConstants.trans("choose_template")}</Typography>
                          <input type="file" style={{marginTop:10}} onChange={ (e) => this.loadBG(e.target.files) } style={{ width: dropDownWidth}} /> 
                      </div>
                      <div style={{marginLeft:10, paddingBottom:20, marginTop:10, marginRight:10}}>
                          {ETVConstants.ON_PREMISE_VERSION?<span/>:
                            <Button color="primary" size='small' variant='contained' onClick={() => this.showWindow('select_from_templates',true)}>
                                <Typography variant="body2">{ETVConstants.trans("select_from_templates")}</Typography>
                            </Button>
                          }
                      </div>
                    </Paper>
                    <br/>
                    <Paper elevation={3} xs={{marginTop:20}}>
                        <div style={{marginLeft:10, paddingTop:20, marginRight:10}}>
                          <Button color="primary" size='small' variant='contained' onClick={() => this.showWindow('select_screens_div',true)}>{ETVConstants.trans("select_screens")} ({this.state.selected_screens.length})</Button>
                        </div>
                        <div>
                            <FormControl style={{marginLeft:10, marginTop:20, paddingBottom:20}}>
                            <InputLabel id="channelIDLabel">{ETVConstants.trans("channel")}</InputLabel>
                            <Select
                              labelId="ChannelIDLabel"
                              id="channelID"
                              style={{ width: dropDownWidth}}
                              value={this.state.channel}
                              size="small"
                              input={<OutlinedInput label={"channelID"} />}
                              onChange={this.handleChannelChange}>
                                <MenuItem value='0'>{ETVConstants.trans("channel")} 0</MenuItem>
                                <MenuItem value='1'>{ETVConstants.trans("channel")} 1</MenuItem>
                                <MenuItem value='2'>{ETVConstants.trans("channel")} 2</MenuItem>
                                <MenuItem value='3'>{ETVConstants.trans("channel")} 3</MenuItem>
                                <MenuItem value='4'>{ETVConstants.trans("channel")} 4</MenuItem>
                            </Select>
                          </FormControl>
                         </div>
                    </Paper>
                </td>
                <td>
                     <div>
                          {this.state.canvas_bg?
                            <canvas ref="canvas" width={this.state.cWidth} height={this.state.cHeight} style={{border:"1px solid lightgrey", background:'url('+this.state.canvas_bg+')'}}
                                onClick={this.handleCanvasClick}
                                tabIndex="0"
                                onKeyDown={this.onKeyDown}
                                onMouseOut={this.onMouseOut} />
                            :
                            <canvas ref="canvas" width={this.state.cWidth} height={this.state.cHeight} style={{border:"1px solid lightgrey", backgroundColor:this.state.canvas_bg_color}}
                                onClick={this.handleCanvasClick}
                                tabIndex="0"
                                onKeyDown={this.onKeyDown}
                                onMouseOut={this.onMouseOut} />
                          }

                     </div>
                </td>
              </tr>
             </tbody></table>

              <div id='select_screens_div' style={{display:this.state.window==='select_screens_div'?'block':'none'}}>
                    <SelectAvailableScreensNew isOpen={this.state.window==='select_screens_div'} user_id={this.props.user_id} closeHook={this.closeScreenSelection} selected={this.state.selected_screens?this.state.selected_screens:[]} selectedScreens={this.selectedScreens}/>
              </div>

              <MessageDialog type={this.state.info_type} open={this.state.window==='message_div'} onClose={this.closeInfoMessage} title={this.state.info_title} message={this.state.info_message} />

              <Dialog
                open={this.state.window==='select_from_templates'}
                maxWidth='lg'
                fullWidth={true}
                onClose={()=>{}}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{ETVConstants.trans("select_from_templates")}</DialogTitle>
                <DialogContent>
                    {this.state.template_items.length>0?
                          <div>
                              { this.state.template_items.map( item => {
                                    return ( <div key={item.content_id} style={{display: 'inline-block', width:300, height:225, margin: 5}}>
                                                <img src={item.thumbnail} onClick={()=>{this.loadTemplate(item)}} imageStyle={{width:300,height:'inherit'}}/>
                                            </div>
                                          )
                                })}
                          </div>
                      :
                          <span/>
                    }
                </DialogContent>
                <DialogActions>
                  <Button onClick={()=>{this.closeInfoMessage()}} color="primary">{ETVConstants.trans("close")}</Button>
                </DialogActions>
              </Dialog>

          </CardContent>
          <CardActions>
              <Button color="primary" onClick={() => this.resetDrawing()}>{ETVConstants.trans("reset")}</Button>
              {this.state.items.length>0?<Button color="success" size="medium" startIcon={<UploadFileIcon />} variant='contained' onClick={() => this.prepareUploadImage()}>{ETVConstants.trans("upload")}</Button>:<span/>}
          </CardActions>
        </Card>
      )
    }
}

export default EditText;
